import {NotificationDialog} from "./notification-dialog/NotificationDialog";
import NoLivesDialog from "./no-lives/NoLivesDialog";
import QuestionDialog from "./question-dialog/QuestionDialog";
import CreditsDialog from "./credits-dialog/CreditsDialog";
import PurchaseTimeDialog from "./purchase-time-dialog/PurchaseTimeDialog";
import Tutorial from "./tutorial/Tutorial";
import DailyBonusDialog from "./daily-bonus/DailyBonusDialog";
import FormDialog from "./forms/FormDialog";

export const dialogTemplates: Record<string, any> = {
    NotificationDialog: NotificationDialog,
    NoLivesDialog: NoLivesDialog,
    QuestionDialog: QuestionDialog,
    CreditsDialog: CreditsDialog,
    PurchaseTimeDialog: PurchaseTimeDialog,
    Tutorial: Tutorial,
    DailyBonusDialog: DailyBonusDialog,
    FormDialog: FormDialog,
};